import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=fb1c01e0&"
import script from "./WorkerDetail.vue?vue&type=script&lang=js&"
export * from "./WorkerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports